export enum ItemFilters {
  FIRST_SAMPLE = 'First Sample',
  PROTO_DEVELOPMENT = 'Proto Development',
  FIT = 'Fit',
  PRE_PRODUCTION = 'Pre-Production',
  TOP = 'TOP',
  BLOCK = 'Block',
}

export interface SampleCreatedWith {
  trim: 'Available' | 'Production';
  label: 'Available' | 'Production';
  fabric: 'Available' | 'Production';
  wash_color: 'Available' | 'Production';
}

export enum DevelopmentType {
  SAMPLE_REQUEST = 'Sample Request',
  BUYER_REQUESTED = 'Buyer Requested',
  VENDOR_SAMPLE = 'Vendor Sample',
  LUXE = 'LUXE',
  PD_DEVELOPMENT = 'PD Development',
}

export type FiberContent = {
  id: string;
  fiber: string;
  percent_of_fibers: number;
};

export type FabricSection = {
  id: string;
  fiberContents: FiberContent[];
  fabricWeight: string;
  fabricCodeName: string;
};

export type AddTagFormData = {
  sampleType: ItemFilters;
  fiberContents?: FiberContent[];
  styleNumber?: string;
  customCutLeadTime?: number;
  ccLeadTimeDate?: string;
  coo?: string;
  shipmentMode?: string;
  productImageUrl?: string;
  productImageFile?: File;
  poDueDate?: string;
  poLineName?: string;
  poLineColor?: string;
  poLineSize?: string;
  styleName?: string;
  fabricWeight?: string;
  fabricCodeName?: string;
  poNumber?: string;
  selectedProduct?: string;
  dateSent?: string;
  cutDate?: string;
  typeOfDevelopment?: DevelopmentType;
  sampleSize?: string;
  colorWash?: string;
  juniorCost?: number;
  juniorMoq?: number;
  plusCost?: number;
  plusMoq?: number;
  comments?: string;
  fnExclusive?: boolean;
  fitSample?: boolean;
  fabricType?: 'Available' | 'Production';
  trimType?: 'Available' | 'Production';
  labelType?: 'Available' | 'Production';
  washColorType?: 'Available' | 'Production';
  contrastSection?: FabricSection;
  liningSection?: FabricSection;
  fillingSection?: FabricSection;
  coatingSection?: FabricSection;
  backingSection?: FabricSection;
  id?: string;
  division?: string;
  department?: string;
  category?: string;
  class?: string;
  blockNumber?: string;
  pantsAttribute?: string;
  topsAttribute?: string;
  selfShellFabricCode?: string;
};

export interface SampleTagResponse {
  id: string;
  sample_tag_lpn?: string;
  type_of_sample_tag: ItemFilters;
  created_at?: string;
  style_number?: string;
  style_name?: string;
  product_image?: string;
  product_image_signed_url?: string;
  product_image_expires_at?: string;
  po_number?: string;
  product_sku?: string;
  date_sent?: string;
  cut_date?: string;
  custom_cut_lead_time?: number;
  cc_lead_time_date?: string;
  coo?: string;
  shipment_mode?: string;
  fn_exclusive?: boolean;
  fit_sample?: boolean;
  comments?: string;
  type_of_development?: DevelopmentType;
  sample_size?: string;
  color_wash?: string;
  junior_cost?: number;
  junior_moq?: number;
  plus_cost?: number;
  plus_moq?: number;
  sample_created_with?: SampleCreatedWith;
  self?: MaterialSection;
  contrast?: MaterialSection;
  lining?: MaterialSection;
  filling?: MaterialSection;
  coating?: MaterialSection;
  backing?: MaterialSection;
  po_due_date?: string;
  po_line_name?: string;
  po_line_color?: string;
  po_line_size?: string;
  division?: string;
  department?: string;
  category?: string;
  class?: string;
  block_number?: string;
  pants_attribute?: string;
  tops_attribute?: string;
  self_shell_fabric_code?: string;
  coordinating_separates?: Array<{
    style_number: string;
    style_color?: string | null;
  }>;
  productImageDataUrl?: string;
  company_name?: string;
  vendor_legal_name?: string;
}

export interface MaterialSection {
  content: Array<{
    fiber: string;
    percent_of_fibers: number;
  }>;
  fabric_weight?: number;
  fabric_code_name?: string;
}

export interface SampleDetailsField {
  name: 'fnExclusive' | 'fitSample';
  label: string;
  options: Array<{ label: string; value: boolean }>;
}

export interface SampleCreatedWithField {
  name: 'fabricType' | 'trimType' | 'labelType' | 'washColorType';
  label: string;
}
